module.exports = {"370826001":"夏镇街道","370826002":"昭阳街道","370826003":"傅村街道","370826101":"韩庄镇","370826102":"欢城镇","370826103":"南阳镇","370826104":"鲁桥镇","370826106":"留庄镇","370826107":"两城镇","370826108":"马坡镇","370826109":"赵庙镇","370826110":"张楼镇","370826111":"微山岛镇","370826112":"西平镇","370826206":"高楼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370826.json
// module id = 1545
// module chunks = 0